var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.996,
    height: 18.002,
    viewBox: "0 0 17.996 18.002",
    className: "nav-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M19.25,11A1.75,1.75,0,0,1,21,12.752v6.5A1.75,1.75,0,0,1,19.25,21h-4.5A1.75,1.75,0,0,1,13,19.252v-6.5A1.75,1.75,0,0,1,14.75,11ZM9.268,15.014a1.75,1.75,0,0,1,1.75,1.75v2.488A1.75,1.75,0,0,1,9.268,21H4.754A1.75,1.75,0,0,1,3,19.252V16.764a1.75,1.75,0,0,1,1.75-1.75ZM19.25,12.5h-4.5a.25.25,0,0,0-.25.25v6.5a.25.25,0,0,0,.25.25h4.5a.25.25,0,0,0,.25-.25v-6.5A.25.25,0,0,0,19.25,12.5ZM9.268,16.514H4.754a.25.25,0,0,0-.25.25v2.488a.25.25,0,0,0,.25.25H9.268a.25.25,0,0,0,.25-.25V16.764A.25.25,0,0,0,9.268,16.514ZM9.254,3A1.75,1.75,0,0,1,11,4.75v6.5A1.75,1.75,0,0,1,9.4,12.994L9.254,13h-4.5A1.75,1.75,0,0,1,3,11.25V4.75A1.75,1.75,0,0,1,4.754,3Zm0,1.5h-4.5a.25.25,0,0,0-.25.25v6.5a.25.25,0,0,0,.25.25h4.5l.057-.007A.25.25,0,0,0,9.5,11.25V4.75A.25.25,0,0,0,9.254,4.5Zm10-1.5A1.75,1.75,0,0,1,21,4.75v2.5A1.75,1.75,0,0,1,19.25,9h-4.5A1.75,1.75,0,0,1,13,7.25V4.75A1.75,1.75,0,0,1,14.75,3Zm-4.5,1.5a.25.25,0,0,0-.25.25v2.5a.25.25,0,0,0,.25.25h4.5a.25.25,0,0,0,.25-.25V4.75a.25.25,0,0,0-.25-.25Z",
    transform: "translate(-3.004 -3)",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5fa27ee95305457259de7d9b6a1ed1a6.svg";
export { ForwardRef as ReactComponent };